<div class="credit-withdraw-content-container">
  <ng-container
    *ngIf="
      this._UserHelper.depositList != null &&
      this._UserHelper.depositList.length > 0 &&
      (this._DataHelper.selectedWallet.BranchType == 1 ? this._UserHelper.userInsicStatus === 1 || this._UserHelper.userInsicStatus === 2 : true)
    ">
    <div class="credit-input-container">
      <div class="deposit-text-container">
        {{ 'b3000_Withdraw_text_3' | t }}
      </div>
      <inputb3
        [extraClass]="'amountInput'"
        fPlaceholder="{{ 'Amount' | t }}"
        fInputType="number"
        fSuffixText="{{ this._UserHelper.customerUser.Symbol }}"
        [(ngModel)]="amount"></inputb3>
    </div>

    <div class="payment-method-container">
      <div class="payment-method-row" *ngFor="let depositItem of this._UserHelper.depositList">
        <label for="deposit_{{ depositItem.DepositTypeId }}" style="display: flex; width: 100%">
          <div class="payment-left-side">
            <input type="radio" name="deposit-method" id="deposit_{{ depositItem.DepositTypeId }}" value="{{ depositItem.DepositTypeId }}" [(ngModel)]="paymentType" />
            <div class="trustly-icon">
              <image-loader-utils
                [url]="depositItem.Description"
                [imageFormat]="depositItem.DepositTypeId == 85 ? 'png' : 'svg'"
                extraClasses="icon payment-methods-icon"
                altText="deposit_{{ depositItem.PaymentType }}"></image-loader-utils>
            </div>
          </div>
          <div class="payment-right-side">{{ 'b3000_Min' | t }}. {{ depositItem.MinValue }}€</div>
        </label>
      </div>
    </div>
    <div class="deposit-limit-container">
      <div>
        <div class="row-initial">
          {{ 'b3000_Deposit_Text' | t }}
        </div>
        <div class="row-initial bold">
          {{ this._UserHelper.depositList[0]?.DescriptionLong }}
          {{ this._UserHelper.customerUser.Symbol }}
        </div>
        <div class="row-initial">
          {{ 'b3000_Deposit_Text2' | t }}
        </div>
      </div>
      <div class="go-setlimit-container" (click)="OpenAccountMobile(6)">
        {{ 'b3000_Deposit_Text3' | t }}
      </div>
    </div>

    <div class="confirm-button-container">
      <div class="alert-message" *ngIf="alertMessage">
        {{ alertMessageDesc }}
      </div>
      <ng-template #noAmount>
        <div class="btn colored register-button save-changes-button confirm-button opacity">
          <div class="btn-text">{{ 'Confirm' | t }}</div>
        </div>
      </ng-template>
      <div *ngIf="amount >= 10 && paymentType; else noAmount" class="btn colored register-button save-changes-button confirm-button" (click)="confirmButton()">
        <div class="btn-text">{{ 'Confirm' | t }}</div>
      </div>
    </div>
    <div class="payment-sub-text">
      {{ 'b3000_Withdraw_text_2' | t }}
    </div>
    <div class="other-deposit-main-container">
      <div class="other-deposit-uptext">Other deposit methods:</div>
      <div class="bank-transfer-container" (click)="toggleBankTransfer()">
        <div class="btn colored register-button save-changes-button confirm-button">
          <div class="btn-text">Bank Transfer</div>
        </div>
      </div>

      <div class="other-deposit-downtext">It is not permitted to deposit with third party payment accounts. Payment account holder must be the gaming account holder.</div>
      <div class="bank-transfer-dropdown-container" *ngIf="toggleTransfer">
        <div class="bank-transfer-info-row">
          Please note that all bank payments must be made as an EU standard transfer or SEPA transfer in EUR. You may need a special form for this. If you use online banking, there
          is often a separate menu item for EU transfers or SEPA transfers.
        </div>
        <div class="bank-transfer-info-container">
          <div class="bank-info-text">Please use the following data for the transfer:</div>

          <div class="bank-transfer-info-row">
            <div class="bank-info-row-left">Account holder:</div>
            <div class="bank-info-row-right" (click)="copyClickBoard('IBA Entertainment Limited')">
              IBA Entertainment Limited
              <image-loader-utils url="copy" extraClasses="copy-icon"></image-loader-utils>
            </div>
          </div>
          <div class="bank-transfer-info-row">
            <div class="bank-info-row-left">Name of Bank:</div>
            <div class="bank-info-row-right" (click)="copyClickBoard('Emoney PLC')">
              Emoney PLC
              <image-loader-utils url="copy" extraClasses="copy-icon"></image-loader-utils>
            </div>
          </div>
          <div class="bank-transfer-info-row">
            <div class="bank-info-row-left">BIC/SWIFT:</div>
            <div class="bank-info-row-right" (click)="copyClickBoard('EMONMTM2')">
              EMONMTM2
              <image-loader-utils url="copy" extraClasses="copy-icon"></image-loader-utils>
            </div>
          </div>
          <div class="bank-transfer-info-row">
            <div class="bank-info-row-left">IBAN:</div>
            <div class="bank-info-row-right" (click)="copyClickBoard('MT23EMON02015000009000100063958')">
              MT23EMON02015000009000100063958
              <image-loader-utils url="copy" extraClasses="copy-icon"></image-loader-utils>
            </div>
          </div>
          <div class="bank-transfer-info-row">
            <div class="bank-info-row-left">Reason for payment:</div>
            <div class="bank-info-row-right" (click)="copyClickBoard(this._UserHelper?.customerUser?.UserName.toString())">
              {{ this._UserHelper?.customerUser?.UserName }}
              <image-loader-utils url="copy" extraClasses="copy-icon"></image-loader-utils>
            </div>
          </div>
        </div>
        <div class="bank-transfer-info-row">
          The transfer amount is credited to the customer account within a few days using an EU standard transfer or bank transfer.<br />The user name must always be specified in
          the purpose of the transfer form so that Bet3000 can clearly assign the payment.<br />
          The amount transferred by the customer will be credited to his Bet3000 account as soon as it is on the IBA Entertainment Ltd. account. has been received. This process
          usually takes 2-4 bank working days. Chargebacks, cancellation fees and similar costs incurred in the event of an incorrect transfer are borne by the customer.
        </div>
        <div class="bank-transfer-info-row">Bet3000 only accepts transfers from accounts owned by the customer.</div>
      </div>
    </div>
  </ng-container>

  <!-- No-Checked 0 -->

  <ng-container *ngIf="this._DataHelper.selectedWallet.BranchType == 1 && (this._UserHelper.userInsicStatus === 0 || this._UserHelper.userInsicStatus === -2)">
    <div class="deposit-insicStatus-container">
      <div class="insicStatus-row">
        <p class="insicStatus-downtext">
          {{ 'b3000_Deposit_Text_5' | t }}
          <span class="underline-text" (click)="OpenAccountMobile(8)">
            {{ 'b3000_Deposit_Text_2' | t }}
          </span>
        </p>
      </div>
      <div class="insicStatus-row">
        <p class="insicStatus-downtext">
          {{ 'b3000_Deposit_Text_3' | t }}
        </p>
        <div class="btn colored register-button save-changes-button confirm-button green" (click)="OpenAccountMobile(8)">
          <div class="btn-text" style="color: #fff !important">
            {{ 'b3000_Deposit_Text_4' | t }}
          </div>
        </div>
      </div>
    </div>
  </ng-container>
  <!-- Bloked Customer 4 and -1 -->
  <ng-container *ngIf="this._DataHelper.selectedWallet.BranchType == 1 && (this._UserHelper.userInsicStatus === 4 || this._UserHelper.userInsicStatus === -1)">
    <div class="deposit-insicStatus-container">
      <div class="insicStatus-row">
        <p class="insicStatus-downtext" style="font-size: 16px; font-weight: 600">
          {{ 'b3000_Deposit_Text_6' | t }}
          <a href="mailto:support@bet3000.de" style="text-decoration: underline; color: #000; font-size: 16px; font-weight: 600">
            {{ 'b3000_Withdraw_Text_2' | t }}
          </a>
        </p>
      </div>
    </div>
  </ng-container>
</div>
